import { authService } from '../auth-service';
// Use environment variable for backend URL
// Development: http://localhost:8766/api
// Production: /api (proxied by nginx to ALB)
const BACKEND_URL = import.meta.env.VITE_CHAT_BACKEND_URL || '/api';
const API_URL = `${BACKEND_URL}/v2/diary/chat/stream`;
const ADD_MESSAGE_URL = `${BACKEND_URL}/v2/diary/entry`;
export async function sendMessageStream(message, options = {}) {
    const { sessionId, character, onChunk, onSessionId, onError, onDone } = options;
    let fullResponse = '';
    try {
        const token = await authService.getIdToken();
        if (!token) {
            throw new Error('Authentication required');
        }
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                message,
                session_id: sessionId,
                character: character || 'luna',
                is_agentic: true,
            }),
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const reader = response.body?.getReader();
        if (!reader)
            throw new Error('No response body');
        const decoder = new TextDecoder();
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            const chunk = decoder.decode(value, { stream: true });
            const lines = chunk.split('\n');
            for (const line of lines) {
                if (!line.startsWith('data: '))
                    continue;
                try {
                    const data = JSON.parse(line.slice(6));
                    if (data.error) {
                        onError?.(data.error);
                        break;
                    }
                    if (data.type === 'done' || data.done) {
                        if (data.session_id) {
                            onSessionId?.(data.session_id);
                        }
                        onDone?.(data.context);
                        break;
                    }
                    const textContent = data.content || data.text || data.response;
                    if (textContent) {
                        fullResponse += textContent;
                        onChunk?.(fullResponse);
                    }
                    if (data.session_id && onSessionId) {
                        onSessionId(data.session_id);
                    }
                }
                catch {
                    // Skip invalid JSON lines
                }
            }
        }
    }
    catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'Unknown error';
        onError?.(errorMessage);
        throw error;
    }
    return fullResponse;
}
export async function addMessage(message, sessionId) {
    const token = await authService.getIdToken();
    if (!token) {
        throw new Error('Authentication required');
    }
    const response = await fetch(ADD_MESSAGE_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ message, session_id: sessionId, character: 'luna' }),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
}
